import Toast from '@/components/Toast';
import useHomeContext from '@/hooks/useHomeContext';
import React, { useEffect, useRef, useState } from 'react';
import SmallLoadingSpinner from '@/assets/SmallLoadingSpinner.json';
import Lottie from 'react-lottie';
import { getSecondsInMilliseconds } from '@/utils/getMilliseconds';
import { ReactComponent as ExportSuccess } from '@/assets/ExportSuccess.svg';

const ExportToastStatus = {
  IN_PROGRESS: 'in_progress',
  DONE: 'done'
} as const;

const ExportToast: React.FC<React.HTMLProps<HTMLDivElement>> = () => {
  const { exportInProgress } = useHomeContext()!;
  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const [status, setStatus] = useState<string>();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: SmallLoadingSpinner,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  useEffect(() => {
    if (exportInProgress && status == undefined) {
      setStatus(ExportToastStatus.IN_PROGRESS);
    }

    if (!exportInProgress && status === ExportToastStatus.IN_PROGRESS) {
      setStatus(ExportToastStatus.DONE);
      timerRef.current = setTimeout(() => {
        setStatus(undefined);
      }, getSecondsInMilliseconds(5));
    }
  }, [exportInProgress, status]);

  switch (status) {
    case ExportToastStatus.IN_PROGRESS:
      return (
        <Toast size="md" isOpen={status === ExportToastStatus.IN_PROGRESS} variant="info">
          <div className="flex items-center gap-x-4">
            <Lottie options={defaultOptions} height="2.3125rem" width="2.3125rem" />
            <div className="flex flex-col gap-y-2">
              <div className="text-sm font-medium text-emerge-navy">Generating export</div>
              <div className="text-xs font-normal text-emerge-navy-2">
                Your transaction export in progress
              </div>
            </div>
          </div>
        </Toast>
      );
    case ExportToastStatus.DONE:
      return (
        <Toast size="md" isOpen={status === ExportToastStatus.DONE} variant="info">
          <div className="flex items-center gap-x-4">
            <ExportSuccess />
            <div className="flex flex-col gap-y-2">
              <div className="text-sm font-medium text-emerge-navy">Export complete</div>
              <div className="text-xs font-normal text-emerge-navy-2">
                Your transaction export is now complete
              </div>
            </div>
          </div>
        </Toast>
      );
    default:
      return null;
  }
};

export default ExportToast;
